export default class DevelopmentChunkedDownloadController {
	// eslint-disable-next-line class-methods-use-this
	async download() {
		// eslint-disable-next-line no-console
	}
}
